<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5
    
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero.text-white
        span 2
      h1 La propuesta técnica
    

    p.mb-4 La propuesta técnica es el documento que se entrega al posible cliente, en la cual se detalla la estrategia a desarrollar para darle solución a un problema existente, el contenido o formato de una propuesta puede variar según la empresa que lo solicita, si es privada, gubernamental, fundación u ONG, en estos casos se debe adaptar la propuesta a los formatos requeridos de las empresas. Una propuesta debe ser clara, concreta, explícita y fácil de entender.
    
    .row.justify-content-center.mb-4
      .col-lg-12
        figure.mb-5
          img.mx-auto(src='@/assets/curso/tema2/img1.png', alt='imagen ambiental', style='')


    #t_2_1.titulo-segundo.color-acento-contenido
      .h2 2.1 Estructura
    

    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-3
        
        .bg--blue.neg--right.mb-4
          p.mb-0 Cuando se tiene el insumo principal, que es toda la información requerida y analizada, se empieza a estructurar la propuesta que debe tener el siguiente esquema:
          
        .row.justify-content-center.mb-4
          .col-md-10
            ul.lista-ul.ps-md-0
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Saludos y presentación.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Alcance de la propuesta.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Opciones de las propuestas de trabajo (dos o tres).
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Cotización por cada propuesta presentada.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Condiciones (forma de pago).
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Conclusión y despedida.
      
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema2/img2.svg', alt='imagen ambiental', style='width: 600px;')


    
    
    separador
    #t_2_2.titulo-segundo.color-acento-contenido
      .h2 2.2 Términos de Referencia (TdR)
    
    
    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-4
        
        .bg--blue.neg--right.mb-4
          p.mb-0 Es el documento que realiza una empresa en el que plasma las oportunidades de mejora, necesidades o problemas y se las presenta a una empresa o al experto informático para darles solución. Los TdR sirven para que las empresas tengan en claro los servicios que requieren contratar y para que la contraparte sepa en qué condiciones ofrecerán dichos servicios y poder elaborar una propuesta técnica adecuada.
          
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema2/img3.png', alt='imagen ambiental', style='width: 600px;')
    
    
    p.mb-5 Estos son algunos aspectos importantes que usted debe tener en cuenta, en relación con los Términos de Referencia (TdR):
    
    .row.justify-content-center
      .col-lg-10
        LineaTiempoD.color-primario
          .row.justify-content-center(numero="1" titulo="Servicio requerido")
            .col-md-6.mb-4.mb-md-0.align-self-center
              p.mb-0 Los TdR incluyen el servicio que necesita la empresa de forma clara y concisa, los objetivos que se espera lograr con la contratación. En algunos casos se describen las especificaciones técnicas de la solución informática, los requisitos del contratista, el tiempo de ejecución del contrato y las condiciones de pago.
          
            .col-8.col-md-5.align-self-center
              figure
                img.mx-auto(src='@/assets/curso/tema2/img4.svg', alt='imagen ambiental', style='width: 300px')
                
          .row.justify-content-center(numero="2" titulo="Estructura del documento")
            .col-md-6.mb-4.mb-md-0.align-self-center
              p.mb-0 La estructura de este documento tiene una justificación, alcances del servicio, perfil de la empresa a contratar y condiciones contractuales.
              
            .col-8.col-md-5.align-self-center
              figure
                img.mx-auto(src='@/assets/curso/tema2/img5.svg', alt='imagen ambiental', style='width: 300px')
                
          .row.justify-content-center(numero="3" titulo="Cuando la empresa es nueva")
            .col-md-6.mb-4.mb-md-0.align-self-center
              p.mb-0 Cuando una empresa es nueva y no maneja los TdR, lo que el experto informático debe hacer es acordar una reunión con las partes interesadas o también llamadas <em>stakeholders,</em> y hacerles preguntas sobre el funcionamiento de la empresa, los procesos que manejan, servicios que prestan y en qué sector económico están.
              
            .col-8.col-md-5.align-self-center
              figure
                img.mx-auto(src='@/assets/curso/tema2/img6.svg', alt='imagen ambiental', style='width: 300px')
                
          .row.justify-content-center(numero="4" titulo="Dialogar sobre el presupuesto")
            .col-md-6.mb-4.mb-md-0.align-self-center
              p.mb-0 En la mayoría de las ocasiones y en búsqueda de un servicio justo, será posible proponer un diálogo sobre el presupuesto proyectado para la solución de <em>software;</em> así mismo sobre la matriz DOFA de la empresa para tener claras sus necesidades y ofrecerle los servicios adecuados en una propuesta técnica.
              
            .col-8.col-md-5.align-self-center
              figure
                img.mx-auto(src='@/assets/curso/tema2/img7.svg', alt='imagen ambiental', style='width: 300px')
                



    separador
    #t_2_3.titulo-segundo.color-acento-contenido
      .h2 2.3 Elaboración de la propuesta técnica


    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-4
        
        .bg--blue.neg--right.mb-4(style='background-color: #F3F9FF;')
          p.mb-0 Es necesario, entonces, recordar que se debe tener una papelería adecuada que represente al negocio; el formato de documento, físico o virtual, debe contar con un diseño sobrio pero atractivo, el documento debe tener un encabezado en el cual debe ir el nombre de la empresa y el NIT o el nombre de la persona que trabaja <em>freelance,</em> este debe ir acompañado del logo. 
          
        p.mb-4 En el pie de página debe ir la dirección de la empresa y datos de contacto como números telefónicos, correos, WhatsApp, Facebook, Instagram, etc. Se debe tener en cuenta, como insumos principales, los TdR o la entrevista al momento de elaborar la propuesta.
        p.mb-4 Explore el recurso que se presenta a continuación y conozca a profundidad, los aspectos más importantes sobre la elaboración de la propuesta técnica:
          
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema2/img8.png', alt='imagen ambiental', style='width: 600px;')
    

    figure
      .video
        <iframe width="950" height="534" src="https://www.youtube.com/embed/mOO9X9QcNMg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      















    

</template>

<script>
export default {
  name: 'Tema2',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
